export default {
    "fade-in": {
        origin: { opacity: 0 },
        target: { opacity: 1 },
    },
    "fade-up": {
        origin: { opacity: 0, y: 50 },
        target: { opacity: 1, y: 0 },
    },
    "fade-down": {
        origin: { opacity: 0, y: -50 },
        target: { opacity: 1, y: 0 },
    },
    "fade-left": {
        origin: { opacity: 0, x: 50 },
        target: { opacity: 1, x: 0 },
    },
    "fade-right": {
        origin: { opacity: 0, x: -50 },
        target: { opacity: 1, x: 0 },
    },
};
